import { Modal } from "./Modal";
import { Button } from "./Button";

/**
 * Generic confirmation dialog for destructive/bulk actions -- used by
 * batch operations ("this will affect 14 hives") and account actions
 * (revoke device, revoke session, etc.).
 */
export function ConfirmDialog({ open, onClose, onConfirm, title, children, confirmLabel = "Confirm", danger = false, busy = false }) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      size="sm"
      footer={
        <>
          <Button variant="secondary" onClick={onClose} disabled={busy}>
            Cancel
          </Button>
          <Button variant={danger ? "danger" : "primary"} onClick={onConfirm} disabled={busy}>
            {busy ? "Working…" : confirmLabel}
          </Button>
        </>
      }
    >
      {children}
    </Modal>
  );
}
